import React, {useContext} from 'react';

// @ts-ignore
const Context = React.createContext();

export const useDispatchCtx = () => useContext<React.Dispatch<any>>(Context);

export default Context
